import React, { useState } from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { LegalDocument, LegalModal } from './LegalModal';
import { navLinks, LOGO_URL } from './data';
export function Footer() {
  const [activeDocument, setActiveDocument] = useState<LegalDocument | null>(null);
  return <footer className="mt-16 border-t border-brand-border bg-[#faf0e7]" data-id="element-126" data-mp="36oy1baky1z2l">
      <div className="max-w-2xl mx-auto px-6 py-12 text-center" data-id="element-127" data-mp="36n3grxdl48z1">
        <img src={LOGO_URL} alt="Ginger Briones Studio — Hair, Beauty, Wellness" className="h-52 sm:h-64 w-auto object-contain mx-auto mb-5 [mix-blend-mode:darken]" data-id="element-128" data-mp="3ufjuxwu7bgt2" />

        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-6" data-id="element-129" data-mp="3lf56iolxxllc">
          {navLinks.map(link => <a key={link.href} href={link.href} className="font-body text-[10px] tracking-[2px] uppercase text-soft hover:text-gold transition-colors" data-id="element-130" data-mp="3qbvojhhb2r9e">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center justify-center gap-4 mb-7" data-id="element-131" data-mp="2ew70emsbfm70">
          <a href="https://www.instagram.com/gbstudiony/" aria-label="Instagram" className="w-10 h-10 rounded-full border border-champagne-deep/60 flex items-center justify-center text-champagne-deep hover:bg-champagne hover:text-dark transition-colors" data-id="element-132" data-mp="3labt60db0esh">
            <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-133" data-mp="3q8wq9qx9eicp" />
          </a>
          <a href="https://www.facebook.com/GingerBrionesC5/?ref=PROFILE_EDIT_xav_ig_profile_page_web#" aria-label="Facebook" className="social-icon-elevation flex h-10 w-10 items-center justify-center rounded-full border border-champagne-deep/60 text-champagne-deep transition-colors hover:bg-champagne hover:text-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne-deep focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-134" data-mp="3qazrl73v3xwq">
            <Facebook className="w-4 h-4" strokeWidth={1.75} data-id="element-135" data-mp="qu1fbyt0lmgc" />
          </a>
        </div>

        <p className="font-body font-light text-soft text-sm leading-[1.7]" data-id="element-136" data-mp="mt7r14bnu5mx">
          96-02 37th Ave, Corona, NY 11368
          <br data-id="element-137" data-mp="twxtpgfxzmch" />
          WhatsApp&nbsp;
          <a href="https://wa.me/13478886047" target="_blank" rel="noreferrer" className="transition-colors hover:text-gold" data-id="element-138" data-mp="ytxxtlt8ef0y">
            (347) 888-6047
          </a>
          &nbsp;·&nbsp;Llamadas&nbsp;
          <a href="tel:+13472422967" className="transition-colors hover:text-gold" data-id="element-139" data-mp="18kixzdojzrlz">
            (347) 242-2967
          </a>
          <br data-id="element-140" data-mp="1ckt18ikyo3x5" />
          Lunes a domingo&nbsp;·&nbsp;9:30 AM – 8:00 PM
          <br data-id="element-141" data-mp="1hk5y7w5jqrdg" />
          ★★★★★ 5.0 Google Reviews&nbsp;·&nbsp;Queens, New York
        </p>

        <p className="font-serif italic text-gold text-sm mt-5" data-id="element-142" data-mp="1mk1u1843bchx">
          &ldquo;Porque cada mujer merece sentirse en su versión más hermosa.&rdquo;
        </p>

        <div className="mt-7 flex items-center justify-center gap-4 font-body text-[10px] uppercase tracking-[2px] text-soft" data-id="element-143" data-mp="1rgsj2kxvhifh">
          <button type="button" onClick={() => setActiveDocument('privacy')} className="transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-144" data-mp="3ta86l8ynyh68">
            Privacy
          </button>
          <span aria-hidden="true" className="h-3 w-px bg-brand-border" data-id="element-145" data-mp="21nldriltcts4" />
          <button type="button" onClick={() => setActiveDocument('terms')} className="transition-colors hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-146" data-mp="1woi5zqeg89gg">
            Terms
          </button>
        </div>
        <p className="mt-2 font-body text-[10px] text-soft" data-id="element-147" data-mp="2kfe578l8i6xq">Effective July 2026</p>
      </div>

      <LegalModal legalDocument={activeDocument} onClose={() => setActiveDocument(null)} data-id="element-148" data-mp="2fgb0xqd2w4qt" />
    </footer>;
}